export const payments = {
  qrcode: {
    title: "QR Code",
    subtitle: "Escaneie o QR Code para pagar",
  },
  addFunds: {
    title: "Adicionar Créditos",
    subtitle: "Seus créditos serão adicionados automaticamente na confirmação",
    amount: "Quantidade",
    submit: "Adicionar Créditos",
    processing: "Processando...",
    error: "Erro ao adicionar créditos",
    success: "Créditos adicionados com sucesso",
    gateway: "Forma de Pagamento",
    bonus: "Bônus de depósito (3% - 10%)",
    total: "Total (Precisão de 3 decimais 10,000 = R$ 10,00)",
    note: "Você está fazendo uma compra segura.",
  },
  switchPlan: {
    title: "Trocar Plano",
    subtitle: "Escolha seu novo plano de assinatura",
    submit: "Trocar Plano",
    processing: "Processando...",
    error: "Erro ao trocar de plano",
    success: "Plano trocado com sucesso",
  },
  history: {
    client: "Cliente",
    title: "Histórico de Pagamentos",
    empty: "Nenhum histórico de pagamento encontrado",
    date: "Data",
    description: "Descrição",
    type: "Tipo",
    amount: "Quantidade",
    status: "Status",
    actions: "Ações",
  },
  types: {
    prepaid: "Pré-pago",
    subscription: "Assinatura",
    deposit_bonus: "Bônus de depósito",
  },
  status: {
    pending: "Pendente",
    paid: "Pago",
    failed: "Falhou",
    cancelled: "Cancelado",
  },
  pending: {
    pay: "Pagar Pendente",
    payNow: "Pagar Agora",
  },
  error: {
    loading: "Erro ao carregar histórico de pagamento",
  },
};
